export default "__VITE_ASSET__DflAOIXb__"